import React from 'react';
import { MapPin } from 'lucide-react';
import Select from 'react-select';
import countryList from 'react-select-country-list';

const AddressDetails = ({ formData, onChange, onCountryChange, translations }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6 flex items-center">
        <MapPin className="w-5 h-5 mr-2 text-blue-600" />
        {translations("profile.address")}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label htmlFor="country" className="block text-sm font-medium text-gray-700">
          {translations("profile.country")}
          </label>
          <Select
            options={countryList().getData()}
            value={countryList().getData().find(option => option.value === formData.country)}
            onChange={onCountryChange}
            className="mt-1"
            placeholder="Select a country"
          />
        </div>
        <div>
          <label htmlFor="street" className="block text-sm font-medium text-gray-700">
          {translations("profile.street")}

          </label>
          <input
            type="text"
            id="street"
            value={formData.street}
            onChange={onChange}
            className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="doorNumber" className="block text-sm font-medium text-gray-700">
            {translations("profile.doorNumber")}  

            </label>
            <input
              type="text"
              id="doorNumber"
              value={formData.doorNumber}
              onChange={onChange}
              className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          <div>
            <label htmlFor="apartment" className="block text-sm font-medium text-gray-700">
            {translations("profile.apartment")}  

            </label>
            <input
              type="text"
              id="apartment"
              value={formData.apartment}
              onChange={onChange}
              className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        </div>
        <div>
          <label htmlFor="city" className="block text-sm font-medium text-gray-700">
          {translations("profile.city")}  

          </label>
          <input
            type="text"
            id="city"
            value={formData.city}
            onChange={onChange}
            className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label htmlFor="district" className="block text-sm font-medium text-gray-700">
          {translations("profile.district")}  

          </label>
          <input
            type="text"
            id="district"
            value={formData.district}
            onChange={onChange}
            className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label htmlFor="parish" className="block text-sm font-medium text-gray-700">
          {translations("profile.parish")}  

          </label>
          <input
            type="text"
            id="parish"
            value={formData.parish}
            onChange={onChange}
            className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label htmlFor="postalCode" className="block text-sm font-medium text-gray-700">
          {translations("profile.postalCode")}  

          </label>
          <input
            type="text"
            id="postalCode"
            value={formData.postalCode}
            onChange={onChange}
            className="mt-1 block w-full border border-gray-300 rounded-lg shadow-sm p-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};

export default AddressDetails;